import { jsx as t, jsxs as e } from "react/jsx-runtime";

import l from "@ui-components-3/ui/lib/utils/classNames";

import { getSlotType as i, SCHEDULE_SLOT_TYPES as o } from "../../utils.js";

import { getMinutes as r, addMinutes as a, format as s } from "date-fns";

import { useMemo as n, useCallback as u } from "react";

import { useLiveCurrentDate as m } from "../../hooks/useLiveCurrentDate.js";

import { useProviderSchedule as d } from "../../hooks/useProviderSchedule.js";

const p = t => ({
    hours: s(t, "h"),
    minutes: s(t, "mm"),
    amPm: s(t, "aaa")
}), b = ({slot: s, shouldHideTitle: b, staticPosition: h, onAvailableSlotClick: c}) => {
    const {onOpenVisit: f, variantClassNames: x} = d(), {startTime: v, duration: w, pendingVisitId: g} = s || {}, $ = m(), y = n((() => new Date(v)), [ v ]), j = n((() => r(y)), [ y ]), C = n((() => a(new Date(y), w)), [ y, w ]), N = n((() => $.valueOf() > C.valueOf()), [ C, $ ]), k = w < 60 || !!b, P = n((() => {
        const {hours: t, minutes: e, amPm: l} = p(y);
        return k ? j ? `${t}:${e}${l}` : `${t}${l}` : `${t}:${e}`;
    }), [ k, y, j ]), B = n((() => {
        if (k) return "";
        const {hours: t, minutes: e, amPm: l} = p(C);
        return `${t}:${e}${l}`;
    }), [ C, k ]), D = n((() => [ P, B ].filter(Boolean).join(" - ")), [ B, P ]), O = n((() => h ? "auto" : 100 * j / 60 + "%"), [ j, h ]), S = n((() => h ? 24 : 100 * w / 60 + "%"), [ w, h ]), T = n((() => i(s)), [ s ]), V = n((() => ({
        available: {
            root: x.availableSlot,
            title: "text-neutral-800",
            subtitle: "text-neutral-600"
        },
        new: {
            root: "bg-[#5250B1] border-l-[#5250B1]",
            title: "text-white",
            subtitle: "text-white"
        },
        follow_up: {
            root: "bg-[#0C9070] border-l-[#0C9070]",
            title: "text-white",
            subtitle: "text-white"
        },
        disabled: {
            root: "bg-neutral-200 border-l-neutral-200",
            title: "text-neutral-500",
            subtitle: "text-neutral-500"
        }
    })), [ x ]), z = n((() => N ? V.disabled : V[T || "available"]), [ V, N, T ]), A = u((() => {
        g ? f?.(g) : c?.();
    }), [ c, f, g ]);
    return t("button", {
        type: "button",
        className: l("w-full transition-transform hover:z-[10000] hover:scale-105 disabled:pointer-events-none", !h && "absolute left-0 px-0.5 py-[1px]"),
        style: {
            top: O,
            height: S
        },
        onClick: A,
        disabled: N,
        children: e("div", {
            className: l("flex h-full w-full gap-x-1 rounded border-l-8 px-1.5", w >= 60 ? "flex-col items-start justify-center" : "items-center", z.root),
            children: [ t("p", {
                className: l("typography-small overflow-hidden text-ellipsis whitespace-nowrap font-semibold leading-4", z.title),
                children: b ? D : o[T || "available"]
            }), !b && t("p", {
                className: l("typography-small shrink-0 text-[10px] font-medium leading-4", z.subtitle),
                children: D
            }) ]
        })
    });
};

export { b as default };
//# sourceMappingURL=index.js.map
